import { useUser } from '../../contexts/UserContext';
import { SimpleDialog } from '../SimpleDialog';
import { LoginForm } from './LoginForm';
import { LoginHeader } from './LoginHeader';
import { Progress } from '../ProgressBar/Progress';

export const LoginDialog = () => {
  const { email, isRefreshing, loading, login, resetPassword } = useUser();

  const handleReset = (username: string) => {
    resetPassword(username);
  };

  if (isRefreshing) return null;

  return (
    <SimpleDialog
      fullWidth
      maxWidth="sm"
      open={email === undefined}
      onClose={() => {}}
      userCanClose={false}
    >
      {!email ? (
        <>
          <LoginHeader />
          {loading ? <Progress indeterminate /> : null}
          <LoginForm
            email={email}
            loading={loading}
            login={login}
            onForgotPassword={handleReset}
          />
        </>
      ) : (
        <div />
      )}
    </SimpleDialog>
  );
};
